var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterTick = function SvgFilterTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#171D38",
    strokeWidth: 1.5,
    d: "M6.406 14.21a1.534 1.534 0 0 1-1.572.134 1.44 1.44 0 0 1-.595-.54 1.34 1.34 0 0 1-.196-.758v-3.66c0-.704-.293-1.38-.814-1.881zm0 0 .998-.697zm4.565-12.96h.003a.92.92 0 0 1 .63.241c.16.15.243.344.246.54v1.656a.7.7 0 0 1-.07.313.8.8 0 0 1-.208.27l-3.11 2.627-.01.008a3.4 3.4 0 0 0-1.118 1.96l-.006.032-.003.034-.022.251-.05.539.223.021h-.227v2.683a.5.5 0 0 1-.066.253.6.6 0 0 1-.196.211l-.006.004-.006.005-.998.697-.007.005-.007.005a.784.784 0 0 1-.798.066.7.7 0 0 1-.285-.257.6.6 0 0 1-.087-.334V9.386A3.37 3.37 0 0 0 3.75 6.965L.99 4.301.988 4.3a.75.75 0 0 1-.238-.538V2.03a.75.75 0 0 1 .244-.539.92.92 0 0 1 .628-.242z",
    opacity: 0.8
  })));
};
export default SvgFilterTick;